
export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL ? `${process.env.REACT_APP_API_BASE_URL}/api/v1` : 'http://localhost:3030/api/v1';
export const INPUTADMIN = "input.admin";
export const API_URLS = {
  AUTH: {
    LOGIN: `${BASE_API_URL}/auth-mgmt/login`,
    CHANGE_PASSWORD: `${BASE_API_URL}/auth-mgmt/change_password`,
    RESET_PASSWORD: `${BASE_API_URL}/auth-mgmt/reset_password`,
    REFRESH_TOKEN: `${BASE_API_URL}/auth-mgmt/refresh_token`,
  },
  HOME: {
    GET_COUNTS: `${BASE_API_URL}/input/home-mgmt/get_counts`,
  },
  USER: {
    GET_ALL_USERS: `${BASE_API_URL}/input/user-mgmt/get_users`,
    CREATE_USER: `${BASE_API_URL}/input/user-mgmt/create_user`,
    UPDATE_USER: `${BASE_API_URL}/input/user-mgmt/update_user`,
    DISABLE_USER: `${BASE_API_URL}/input/user-mgmt/delete_user`,
  },
  COMPANY: {
    GET_COMPANIES: `${BASE_API_URL}/input/company-mgmt/get_companies`,
    CREATE_COMPANY: `${BASE_API_URL}/input/company-mgmt/create_company`,
    UPDATE_COMPANY: `${BASE_API_URL}/input/company-mgmt/update_company`,
    DELETE_COMPANY: `${BASE_API_URL}/input/company-mgmt/delete_company`,
  },
  PRODUCT: {
    GET_PRODUCTS: `${BASE_API_URL}/input/product-mgmt/get_products`,
    CREATE_PRODUCT: `${BASE_API_URL}/input/product-mgmt/create_product`,
    UPDATE_PRODUCT: `${BASE_API_URL}/input/product-mgmt/update_product`,
    DELETE_PRODUCT: `${BASE_API_URL}/input/product-mgmt/delete_product`,
    GET_CONTAINER_TYPES: `${BASE_API_URL}/input/product-mgmt/get_container_types`,
  },
  SHIFT: {
    GET_SHIFTS: `${BASE_API_URL}/input/shift-mgmt/get_shifts`,
    CREATE_SHIFT: `${BASE_API_URL}/input/shift-mgmt/create_shift`,
    UPDATE_SHIFT: `${BASE_API_URL}/input/shift-mgmt/update_shift`,
    DELETE_SHIFT: `${BASE_API_URL}/input/shift-mgmt/delete_shift`,
  },
  SECTION: {
    GET_SECTIONS: `${BASE_API_URL}/input/section-mgmt/get_sections`,
    CREATE_SECTION: `${BASE_API_URL}/input/section-mgmt/create_section`,
    UPDATE_SECTION: `${BASE_API_URL}/input/section-mgmt/update_section`,
    DELETE_SECTION: `${BASE_API_URL}/input/section-mgmt/delete_section`,
    GET_SECTION_TYPES: `${BASE_API_URL}/input/section-mgmt/get_section_types`,
  },
  SECTION_LINE: {
    GET_SECTION_LINES: `${BASE_API_URL}/input/section-line-mgmt/get_section_lines`,
    CREATE_SECTION_LINE: `${BASE_API_URL}/input/section-line-mgmt/create_section_line`,
    UPDATE_SECTION_LINE: `${BASE_API_URL}/input/section-line-mgmt/update_section_line`,
    DELETE_SECTION_LINE: `${BASE_API_URL}/input/section-line-mgmt/delete_section_line`,
  },
  SECTION_SHIFT: {
    GET_SECTION_SHIFTS: `${BASE_API_URL}/input/section-shift-mgmt/get_section_shifts`,
    CREATE_SECTION_SHIFT: `${BASE_API_URL}/input/section-shift-mgmt/create_section_shift`,
    DELETE_SECTION_SHIFT: `${BASE_API_URL}/input/section-shift-mgmt/delete_section_shift`,
  },
  DRIVER: {
    GET_ALL_DRIVERS: `${BASE_API_URL}/input/driver-mgmt/get_drivers`,
    CREATE_DRIVER: `${BASE_API_URL}/input/driver-mgmt/create_driver`,
    UPDATE_DRIVER: `${BASE_API_URL}/input/driver-mgmt/update_driver`,
    DISABLE_DRIVER: `${BASE_API_URL}/input/driver-mgmt/delete_driver`,
  },
  ROLE: {
    GET_ROLES: `${BASE_API_URL}/input/role-mgmt/get_roles`,
    CREATE_ROLE: `${BASE_API_URL}/input/role-mgmt/create_role`,
    UPDATE_ROLE: `${BASE_API_URL}/input/role-mgmt/update_role`,
    DELETE_ROLE: `${BASE_API_URL}/input/role-mgmt/delete_role`,
    GET_ROLE_NAMES: `${BASE_API_URL}/input/role-mgmt/get_role_names`,
  },
  USER_ROLE: {
    GET_USER_ROLES: `${BASE_API_URL}/input/user-role-mgmt/get_user_roles`,
    CREATE_USER_ROLE: `${BASE_API_URL}/input/user-role-mgmt/create_user_role`,
    UPDATE_USER_ROLE: `${BASE_API_URL}/input/user-role-mgmt/update_user_role`,
  },
  CHALLAN: {
    GET_CHALLAN: `${BASE_API_URL}/input/delivery-challan-mgmt/get_challan`,
    GET_CHALLAN_BY_ID: `${BASE_API_URL}/input/delivery-challan-mgmt/get_challan`,
  },
  LOGS: {
    GET_ALL_LOGS: `${BASE_API_URL}/input/log-mgmt/get_logs`,
  },  
};
